const zenDeskBaseUrl =
  'https://gradesfirst.zendesk.com/access/jwt?return_to=https%3A%2F%2Fagencyservices.youvisit.com%2Fhc%2Fen-us%2Fsections%2F360010500654-Audience-Analytics-Portal-AAP&jwt=';

export default zenDeskBaseUrl;
